import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../../AlertBox";
import { RequiredAsterisk } from "../../FormHelper";
import { createOdp } from "../../../api/infrastructure";
import OltForm from "../../project/OltForm";

export default function ModalCreateOdp({ show, onClose, onSuccess }) {
  let [form, setForm] = useState({
    code: "",
    description: "",
    olt: null,
  });
  let [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const handleClose = () => {
    setForm({
      code: "",
      description: "",
      olt: null,
    });
    setAlert({ show: false, message: "", type: "" });
    onClose();
  };

  const submitData = (event) => {
    event.preventDefault();
    let formData = {
      code: form.code,
      description: form.description,
      olt_id: form.olt?.value || "",
    };
    sendCreateOdp(formData);
  };

  const sendCreateOdp = async (form) => {
    setLoading(true);
    try {
      let response = await createOdp(form);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <form onSubmit={(event) => submitData(event)}>
        <Modal.Header closeButton>
          <Modal.Title>Buat ODP Baru</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="form-group">
            <label>
              Kode ODP <RequiredAsterisk />{" "}
            </label>
            <input
              type="text"
              className="form-control"
              required
              value={form.code}
              onChange={(event) => setForm({ ...form, code: event.target.value })}
            />
          </div>
          <div className="form-group">
            <label label="OLTid">
              OLT <RequiredAsterisk />
            </label>
            <OltForm
              value={form.olt}
              onChange={(value) => setForm({ ...form, olt: value })}
              required
            />
          </div>
          <div className="form-group">
            <label>
              Deskripsi <RequiredAsterisk />{" "}
            </label>
            <textarea
              className="form-control"
              rows={4}
              value={form.description}
              onChange={(event) => setForm({ ...form, description: event.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => handleClose()}>
            Close
          </button>
          <button type="submit" disabled={loading} className="btn btn-primary">
            <i className="fas fa-plus"></i> {loading ? "Membuat ODP ..." : "Buat ODP Baru"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
